/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salty_Elegant_Jellyfish_AmazeInputs */

const fr_salty_elegant_jellyfish_amaze = /** @type {(inputs: Salty_Elegant_Jellyfish_AmazeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séances`)
};

/**

* @param {Salty_Elegant_Jellyfish_AmazeInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const salty_elegant_jellyfish_amaze = /** @type {((inputs?: Salty_Elegant_Jellyfish_AmazeInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salty_Elegant_Jellyfish_AmazeInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_salty_elegant_jellyfish_amaze(inputs)
});